export const CUSTOMER_HABITS = "customerhabits"
export const HABITS = "habits"
export const RETENTION = "retention"
export const TICKET_INFORMATION = "ticket"
export const PAYMENT = "payment"
export const FREQUENCY = "frequency"
export const TRANSACTIONS = "transactions"
export const PURCHASES = "purchases"
export const RECENCY = "recency"
export const CHANNELS = "channels"
export const TEMPORAL = "temporal"
export const WEEK = "week"
export const HOUR = "hour"
export const SPEND = "spend"
export const ENGLISH = "en"
